import Vue              from 'vue'
import VModal           from 'vue-js-modal'
import App              from './App.vue'
import { authMixin }    from './mixins/authMixin'
import { generalMixin } from './mixins/generalMixins'
import { serviceMixin } from './mixins/serviceMixin'
import router           from './router'
import { centralStore } from './store/store'
import VueI18n          from 'vue-i18n'
import VueMoment        from 'vue-moment'
import messages         from './messages/messages'
import Loading          from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import MonthPicker from 'vue-month-picker'
import MonthPickerInput from 'vue-month-picker'
import money from 'v-money'
import wysiwyg from "vue-wysiwyg";

Vue.config.productionTip = false

// mixins
Vue.mixin(authMixin)
Vue.mixin(generalMixin)
Vue.mixin(serviceMixin)

// plugins
Vue.use(Loading)
Vue.use(VueI18n)
Vue.use(VueMoment)
Vue.use(VModal, {dynamic: true, injectModalsContainer: true})
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)
Vue.use(money)
Vue.use(wysiwyg, {});

const i18n = new VueI18n({
  locale: centralStore.getters.getLocale,
  messages: messages
})

new Vue({
  i18n,
  store: centralStore,
  router,
  render: h => h(App),
}).$mount('#app')
